import React, {useEffect} from "react";

import stylesGlobal from "../../../../ListItem.module.scss";

import cn from "classnames";

const BlacklistSearchItem = ( { item, link, lineNumber, active, setLineLinks} ) => {

    useEffect(() => {
        if (!isNaN(lineNumber)) {
            setLineLinks(links => ({
                ...links,
                [lineNumber]: link,
            }))
        }
    }, [lineNumber, link]);

    return (
        <li className={cn(stylesGlobal.item, {[stylesGlobal.activeLine]: active === 0})}>
            <svg className={stylesGlobal.loupe}>
                <use href="/webpack/dist/sprite.svg#icon-search"></use>
            </svg>
            <a href={`/blacklists/${link}`} className={stylesGlobal.link}>
                {link} in <span className={stylesGlobal.blue}>Block Lists</span>
            </a>
        </li>
    )
};

export default BlacklistSearchItem;
